import { Controller } from "@hotwired/stimulus"

// Toggle clair/sombre du header. Clair par défaut ; le choix est mémorisé
// dans localStorage et appliqué avant le premier rendu par le script inline
// du <head> (pas de flash au chargement).
const THEME_KEY = "theme"
const DARK_META_COLOR = "#101e10"
const LIGHT_META_COLOR = "#294227"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.render()
  }

  toggle() {
    const dark = !document.documentElement.classList.contains("dark")
    document.documentElement.classList.toggle("dark", dark)
    try { localStorage.setItem(THEME_KEY, dark ? "dark" : "light") } catch (e) {}
    this.render()
  }

  render() {
    const dark = document.documentElement.classList.contains("dark")
    if (this.hasIconTarget) this.iconTarget.textContent = dark ? "☀️" : "🌙"
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.content = dark ? DARK_META_COLOR : LIGHT_META_COLOR
  }
}
